import React from 'react';
import TransferDataTable from "./TransferDataTable";

const Transfer = () => {
    return (<TransferDataTable/>);
};

export default Transfer;